// Copyright (c) 2025 GeoVerses. All rights reserved.

import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

const AccuracyWarningDialog = ({ open, accuracy, onClose }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Location Accuracy Warning</DialogTitle>
    <DialogContent>
      <Typography variant="body1">
        Your current location accuracy is approximately <strong>{accuracy} meters</strong>. This may result in inaccurate poem placement and reading.
      </Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>
        For best results, try moving to an area with better GPS signal or enable high accuracy mode in your device settings.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={onClose}>OK</Button>
    </DialogActions>
  </Dialog>
);

export default AccuracyWarningDialog;
